"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateTextHeader = void 0;
const types_1 = require("../types");
const react_1 = __importDefault(require("react"));
const ConditionalOptimizer_1 = __importDefault(require("../wrappers/ConditionalOptimizer"));
/**
 * This is a helper function to create the most typical type of Form component, one that supports conditional display,
 * repeatable fields, field level validation, and read only support
 * @param controlProvider The map of controls from which to grab the consumer's implementation
 * @param componentType the form component type name that we are building
 */
const generateTextHeader = (controlProvider) => {
    const TextHeader = (props) => {
        const Control = controlProvider['textheader'];
        const { controlDefinition, controlPath } = props;
        if (Control) {
            return (react_1.default.createElement(ConditionalOptimizer_1.default, { conditionalMap: (0, types_1.isV2ConditionalComponent)(controlDefinition) ? controlDefinition.conditionalMap : undefined },
                react_1.default.createElement(Control, { functionDefinitions: props.functionDefinitions, controlDefinition: controlDefinition, controlPath: controlPath })));
        }
        return null;
    };
    return TextHeader;
};
exports.generateTextHeader = generateTextHeader;
